import React, { useEffect, useRef, useState } from 'react';
import Slider from '@mui/material/Slider';
import css from './SizeFilter.module.css';
import checkIcon from './check_icon.png';
import './Slider.css';

const SizeFilter = ({ initialValues, onSubmit }) => {
  const queryValues = initialValues?.pub_size?.split(',')?.map(v => Number(v));
  const formattedInitialValues = initialValues?.pub_size?.split(',')?.map(v => Number(v)) || [
    0,
    900,
  ];
  const wrapperRef = useRef(null);
  const [range, setRange] = useState(formattedInitialValues);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setRange(formattedInitialValues);
  }, [formattedInitialValues[0], formattedInitialValues[1]]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleChange = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    if (activeThumb === 0) {
      setRange([newValue[0], range[1]]);
    } else {
      setRange([range[0], newValue[1]]);
    }
  };

  const handleChangeCommited = () => {
    // onSubmit({
    //   pub_size: `${range[0]},${range[1]}`,
    // });
  };

  const handleClickOutside = event => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  return (
    <div className={css.wrapper} ref={wrapperRef}>
      <div
        className={`${css.openButton} ${queryValues && css.focusedButton}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={queryValues && css.marginLabel}>
          Size {queryValues && `: ${range[0]} - ${range[1]} Mb`}
        </span>{' '}
        <img src={checkIcon} className={css.icon} />
      </div>
      {isOpen && (
        <div className={css.controls}>
          <p className={css.label}>
            Size: {range[0]} - {range[1]} Mb
          </p>
          <Slider
            value={range}
            onChange={handleChange}
            // onChangeCommitted={handleChangeCommited}
            valueLabelDisplay="auto"
            disableSwap
            min={0}
            max={900}
            step={10}
          />
          <div className={css.controlButtons}>
            <div
              className={css.reset}
              onClick={() => {
                onSubmit({
                  pub_size: null,
                });
                setIsOpen(false);
              }}
            >
              Reset
            </div>
            <div
              className={css.apply}
              onClick={() => {
                onSubmit({
                  pub_size: `${range[0]},${range[1]}`,
                });
                setIsOpen(false);
              }}
            >
              Apply
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SizeFilter;
